<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
        <label>Thao tác</label>
        <div class="dropdown btn-group" style="height: 36px;">
          <button class="btn">
            <div class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.selectedAll"
                  @change="changeSelectAll"
                  id="selectedAll"
                />
                <label class="custom-control-label" for="selectedAll"></label>
              </div>
            </div>
          </button>
          <button
            type="button"
            class="dropdown-toggle dropdown-toggle-split btn"
            data-toggle="dropdown"
            aria-expanded="false"
            aria-haspopup="true"
          ></button>
          <div class="dropdown-menu">
            <button
              :disabled="actionData.model.listCategorySelectedId.length === 0"
              class="dropdown-item"
              @click="setupSelectOneAction('delete_list')"
              color="danger"
            >
              <CIcon name="cil-trash" style="danger" class="mr-2"/>
              Xóa tất cả
            </button>
          </div>
        </div>
      </CCol>
      <CCol sm="3" md="3" xl="2" xs="12">
        <BaseInput
          :options="nameInput.options"
          :data="nameInput.data"
          :listener="nameInput.listener"
        />
      </CCol>
      <!--      <CCol sm="3" md="3" xl="2" xs="12">-->
      <!--        <BaseSelect :options="statusSelect.options" :data="statusSelect.data"-->
      <!--                    ref="statusSelect"></BaseSelect>-->
      <!--      </CCol>-->
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
            <CButton
              style="float: right;"
              color="primary"
              v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary"
              @click="clickAdd()"
            >
              <i class="fa fa-plus"></i>&nbsp;&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listCategorySelectedId"
                  :value="item.id"
                  :id="item.id"
                  v-c-tooltip.hover="'Selected'"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>

          <template #createDate="{item}">
            <td>
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
          </template>
          <template #name="{item}">
            <td>
              <span style="font-weight: 550;">{{ item.name }}</span>
            </td>
          </template>

          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Cập nhật'"
                  square
                  size="sm"
                  @click="loadFileTypeById(item.id)"
                >
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click="setupSelectOneAction('delete_one', item.id, item.name)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <CModal :title="dataSave.idField.data.model ? 'Cập nhật lĩnh vực' : 'Thêm mới lĩnh vực'" :show.sync="isShowModal"
            :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol sm="12" md="12" xl="12" xs="12">
          <BaseInput
            :options="dataSave.nameInput.options"
            :data="dataSave.nameInput.data"
            :listener="dataSave.nameInput.listener"
          />
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="submitData()"><i class="fa"
                                                                               :class="dataSave.idField.data.model ? 'fa-check' : 'fa-plus'"></i>
          {{ dataSave.idField.data.model ? 'Cập nhật' : 'Thêm mới' }}
        </button>
      </template>
    </CModal>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";

export default {
  name: "FileType",
  components: {
    BaseSwitch,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/file-type/deleteById",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "lĩnh vực",
          that.actionData.model.fileTypeSelectedName
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.fileTypeSelectedId,
        };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Xóa lĩnh vực " + that.actionData.model.fileTypeSelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("delete_list", {
      url: "/file-type/delete-ids",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "các lĩnh vực", "đã chọn");
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          lsId: that.actionData.model.listCategorySelectedId
        };
      },
      successCallback: function () {
        that.actionData.model.listCategorySelectedId = [];
        that.showSuccessMsg({message: "Xóa danh sách lĩnh vực thành công"});
        that.loadDataMainTable();
      },
    });

    return {
      isShowModal: false,
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          fileTypeSelectedId: null,
          fileTypeSelectedName: null,
          listCategorySelectedId: []
        }
      },
      nameInput: {
        options: {
          placeholder: "Tên lĩnh vực",
          label: 'Tên lĩnh vực'
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          noPaging: true,
          fields: [
            {key: "checkbox", label: "#"},
            {key: "createDate", label: "Ngày tạo"},
            {key: "name", label: "Tên lĩnh vực"},
            {key: "action", label: "Thao tác"}
          ],
          slots: ["checkbox", "name", "createDate", "action"],
        },
        dataSource: {
          url: "/file-type/list-type",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          ignoreDefaultData: true,
          isJsonContentType: false,
          response: function (dataResponse) {
            return dataResponse.data;
          },
          resultListAttrName: 'result',
        }
      },
      dataSave: {
        idField: {
          data: {
            name: "id",
            model: ""
          }
        },
        /* name */
        nameInput: {
          options: {
            label: "Tên lĩnh vực <span class='required'>*</span>",
            placeholder: "Tên lĩnh vực",
            maxlength: 500
          },
          data: {
            name: "name",
            model: "",
            updateCallback: function () {
              that.submitData();
            },
            validator: {
              isValid: true,
              errorMessage: "",
              valid: function () {
                let value = that.dataSave.nameInput.data.model;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = "Tên lĩnh vực không được để trống";
                } else if (value.length > 500) {
                  this.isValid = false;
                  this.errorMessage = "Tên lĩnh vực được quá 500 kí tự";
                } else {
                  this.isValid = true;
                }
                return this.isValid;
              }
            }
          }
        }
      }
    }
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    changeSelectAll: function (event) {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listCategorySelectedId = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listCategorySelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listCategorySelectedId = [];
      }
    },
    setupSelectOneAction: function (actionTypeKey, fileTypeSelectedId, fileTypeSelectedName) {
      let actionData = this.actionData.model;
      actionData.fileTypeSelectedId = fileTypeSelectedId || null;
      actionData.fileTypeSelectedName = fileTypeSelectedName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    clickAdd() {
      this.isShowModal = true;
      this.dataSave.idField.data.model = "";
      this.dataSave.nameInput.data.model = "";
    },
    loadFileTypeById(id) {
      let that = this;
      that.isShowModal = true;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/file-type/findById",
        isJsonContentType: false,
        dataSubmit: function () {
          return {id: id}
        },
        successCallback: function (response) {
          that.isShowModal = true;
          that.$helper.setupDataResponse(that.$data.dataSave, response.data.data);
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitData() {
      let that = this;
      let urlSubmit = "/file-type/create";
      if (this.dataSave.idField.data.model) {
        urlSubmit = "/file-type/update";
      }
      this.$helper.loadDataSource({
        loading: that.loading,
        url: urlSubmit,
        dataRef: function () {
          return that.$data.dataSave;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data.dataSave);
          } else {
            that.showSuccessMsg({message: that.dataSave.idField.data.model ? "Cập nhật lĩnh vực thành công" : "Thêm mới lĩnh vực thành công"});
            that.isShowModal = false
            that.loadDataMainTable()
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    "actionData.model.listCategorySelectedId": function (newValue) {
      let that = this;
      if (newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
      } else {
        that.actionData.model.selectedAll = false;
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
